export const ChatDateLabel: React.FC<{ date: string }> = ({ date }) => {
  return (
    <div className='sticky top-0 z-[8] m-auto mt-[-13px] h-[26px] w-fit'>
      <time className='rounded-[100px] border border-gray-200 bg-white px-4 py-1 text-xs font-medium'>
        {date}
      </time>
    </div>
  );
};
